import Storage from '@/utils/Storage'
import Http from '@/utils/Http'

let Base64 = require('js-base64').Base64

const setUser = function (user) {
  return Storage.set('auth_user', user)
}

const getUser = function () {
  return Storage.get('auth_user', {})
}

const setAccessToken = function (token) {
  return Storage.set('auth_token', token)
}

const getAccessToken = function () {
  const token = Storage.get('auth_token', '')

  try {
    if (JSON.parse(Base64.decode(token.split('.')[1])).exp * 1000 > (new Date()).getTime()) {
      return token
    }
  } catch (e) {
  }

  setAccessToken('')
  return ''
}

const isLogin = function () {
  return !!getAccessToken()
}

const getPermissions = function () {
  return Storage.get('auth_permissions', {})
}

const setPermissions = function (permissions) {
  return Storage.set('auth_permissions', permissions)
}

const getRoles = function () {
  return Storage.get('auth_roles', {})
}

const setRoles = function (roles) {
  return Storage.set('auth_roles', roles)
}

const checkRole = function (role) {
  let roles = getRoles()
  return Object.keys(roles).indexOf(role) > -1
}

const checkPermission = function (permissions, permission) {
  if (!Array.isArray(permissions)) {
    permissions = Object.keys(permissions)
  }

  if (permissions.indexOf(permission) > -1 || permissions.indexOf(permission + '/*') > -1) {
    return true
  }

  let pos = permission.lastIndexOf('/')
  while (pos > -1) {
    pos = permission.lastIndexOf('/')
    permission = permission.substring(0, pos)
    if (permissions.indexOf(permission + '/*') > -1) {
      return true
    }
  }

  return false
}
const requireAuth = function (allowList, to, from, next) {
  if (checkPermission(allowList, to.path)) {
    next()
    return
  }

  if (isLogin()) {
    if (can(to.path)) {
      next()
    } else {
      can(to.path, allow => {
        if (allow) {
          next()
        } else {
          next({name: 'Error', query: {code: 403, message: '无权访问资源', from: from.fullPath}})
        }
      })
    }
  } else {
    next({name: 'Login', query: {next: to.fullPath}})
  }
}
const can = function (item, callback) {
  if (callback) {
    Http.fetch('/api/auth/limits', {}, result => {
      setRoles(result.data.roles)
      setPermissions(result.data.perms)
      callback(checkRole(item) || checkPermission(getPermissions(), item))
    }, error => {
      callback(error.status)
    })
  } else {
    return checkRole(item) || checkPermission(getPermissions(), item)
  }
}
export default {
  requireAuth,
  setUser,
  getUser,
  setAccessToken,
  getAccessToken,
  getPermissions,
  setPermissions,
  getRoles,
  setRoles,
  checkPermission,
  checkRole,
  isLogin,
  can
}



// WEBPACK FOOTER //
// ./src/auth/Auth.js